import { SOR } from "../../globalTypes";
import { RowKey, Table } from "../table/types";
import wrappedAxios from "../axiosWrapper";

import * as urlParsers from "./urlParsers";
import {
  changePasswordFormData,
  SettingsUserData,
  User,
  UserFormData,
} from "./types";
import { LoginDTO } from "../login/types";

export const requestDeleteUser = (userId: number) =>
  wrappedAxios<string>({
    url: urlParsers.deleteUser(userId),
    method: "delete",
  });

export const requestGetUser = (userId: number) =>
  wrappedAxios<User>({
    url: urlParsers.getUser(userId),
    method: "get",
  });

// Please use administration/fetchAdminTableData
export const fetchAdministrationUserTable = (
  pageNum: number,
  maxPageRowCount: number,
  searchOrder: SOR,
  hiddenColumns: string[],
  fulltextKeyword: string | undefined
) =>
  wrappedAxios<Table>({
    url: urlParsers.getAdministrationUserTable(
      pageNum,
      maxPageRowCount,
      JSON.stringify(searchOrder),
      hiddenColumns,
      fulltextKeyword
    ),
    method: "GET",
  });

export const insertUserTableRow = (userData: UserFormData) =>
  wrappedAxios<string>({
    url: urlParsers.postUser(),
    method: "POST",
    data: userData,
  });

export const updateUserTableRow = (
  userData: UserFormData,
  rowId: string | number
) =>
  wrappedAxios<string>({
    url: urlParsers.updateUser(rowId),
    method: "PATCH",
    data: userData,
  });

export const updateSettingsUserData = (
  userData: SettingsUserData,
  userId: number
) =>
  wrappedAxios<string>({
    url: urlParsers.updateUser(userId),
    method: "PATCH",
    data: userData,
  });

export const changePassword = (formData: changePasswordFormData) =>
  wrappedAxios<string>({
    url: urlParsers.changePassword(),
    method: "POST",
    headers: {
      oldPassword: formData.oldPassword,
      newPassword: formData.newPassword,
    },
  });

export const newPasswordAfterReset = (password: string) =>
  wrappedAxios<LoginDTO>({
    url: urlParsers.newPasswordAfterReset(),
    method: "post",
    headers: { password },
  });

export const resetPassword = (userId: number) =>
  wrappedAxios<void>({
    url: urlParsers.resetPassword(userId),
    method: "post",
  });

export const resetPasswordBulk = (idsOfUser: Set<RowKey>) =>
  wrappedAxios({
    url: urlParsers.resetPasswordBulk(),
    method: "post",
    data: idsOfUser,
  });

export const postCredentialsForUser = (userId: number) =>
  wrappedAxios<boolean>({
    url: urlParsers.sendCredentials(),
    method: "post",
    params: {
      id: userId,
    },
  });

export const postCredentialsForUsers = (userIds: number[]) =>
  wrappedAxios<boolean>({
    url: urlParsers.sendCredentialsMulti(),
    method: "post",
    data: userIds,
  });
